<template>
    <div class="audio-item">
        <!-- <i class="oneplay" v-if="msgWrapper.msg.msgHasPlayed == 0"></i> -->
        <i class="after" @click="goPlay"></i>
        <img :src="playType?require('@/assets/img/healthy-audio-icon-paly.png'):require('@/assets/img/healthy-audio-icon-stop.png')">
        <div id="waveform" ref="waveform"></div>
        <span class="time" :class="{'wirtime':isMyMsg}">{{srcUrl.len}}"</span>
    </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
export default {
    props:{
        srcUrl:{
            type:Object,
        }
    },
    data () {
        return {
            wavesurfer: null,
            playType:false,
            isMyMsg:false
        }
    },
    mounted () {
        this.$nextTick(() => {
        // console.log(this.$refs);
            this.wavesurfer = WaveSurfer.create({
                container: this.$refs.waveform,
                waveColor:'#fff',
                barWidth: 1,
                cursorColor:"#fff",
                progressColor:"#49AEFF",
                backend:"MediaElement",
                // mediaControls: false,
                audioRate:1,
                //
            });
            // ：require()，
            this.wavesurfer.load(this.srcUrl.url);
        });
    },
    methods:{
        goPlay(){
            if(!this.playType&&this.$store.getters.audioPlayType){
                this.$store.dispatch("video/setPlayType",{type:false,playId:this.srcUrl.url})
                this.wavesurfer.playPause.bind(this.wavesurfer)();
                // if(this.msgWrapper.msg.msgHasPlayed == 0){
                //     this..msg.msgHasPlayed = 1;
                //     let datadd = {
                //         userMsgId:this.srcUrl.url
                //     }
                //     let result =  this.$imapiAxio.post('/im/msg-play', datadd);
                // }
                this.playType = true;
                this.wavesurfer.on('finish',()=>{
                    this.$store.dispatch("video/setPlayType",{type:true,playId:this.srcUrl.url})
                    this.playType = false;
                })
            }else{
                // if(!this.$store.getters.audioPlayType){
                //     if(this.wavesurfer.isPlaying()){
                //         this.wavesurfer.pause();
                //         this.$store.dispatch("video/setPlayType",{type:false,playId:this.srcUrl.url});
                //     }else{
                //         if(this.srcUrl.url == this.$store.getters.playId){
                //             this.wavesurfer.play();
                //         }else{
                //             this.$store.dispatch("video/setPlayType",{type:true,playId:this.srcUrl.url});
                //             this.goPlay();
                //         }
                //     }
                // }else{
                //     if(this.srcUrl.url == this.$store.getters.playId){
                //         this.wavesurfer.play();
                //     }
                //     console.log(";;;123",this.$store.getters);
                // }
                if(this.srcUrl.url == this.$store.getters.playId){
                    if(this.wavesurfer.isPlaying()){
                        this.wavesurfer.pause();
                        this.$store.dispatch("video/setPlayType",{type:true,playId:this.srcUrl.url});
                    }else{
                        this.wavesurfer.play();
                        this.$store.dispatch("video/setPlayType",{type:false,playId:this.srcUrl.url});
                    }
                }else{
                     if(this.$store.getters.audioPlayType){
                        this.wavesurfer.play();
                        this.$store.dispatch("video/setPlayType",{type:false,playId:this.srcUrl.url});
                        this.wavesurfer.on('finish',()=>{
                            this.$store.dispatch("video/setPlayType",{type:true,playId:this.srcUrl.url})
                            this.playType = false;
                        })
                    }
                }
            }
            // window.location.href = url;
        }
    }
};
</script>

<style lang="scss">
.audio-item {
    position: relative;
    // padding: .5rem .4rem;
    display: flex;
    align-items: center;
    background: #49AEFF;
    width: 60%;
    border-radius: 0.5rem;
    padding: 0 0.4rem;
    margin-bottom: 0.4rem;
    & .after {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        display: block;
        left: 0;
        z-index: 9;
    }
    .oneplay {
        width: 0.3rem;
        height: 0.3rem;
        right: -0.4rem;
        background: #f61818;
        border-radius: 50%;
        position: absolute;
        top: 0;
        display: block;
    }
    img {
        width: 0.72rem;
        height: 0.72rem;
        margin-right: 0.3rem;
        flex: 0 0 auto;
    }
    #waveform {
        flex: 1;
        min-width: 4rem;
        height: 1.2rem !important;
        wave {
        height: 1.2rem !important;
        overflow: hidden !important;
        }
    }
    .time {
        flex: 0 0 auto;
        margin-left: 0.2rem;
        font-size: 0.56rem;
        font-weight: 400;
        color: #fff;
    }
    .wirtime {
        color: #fff;
    }
}
</style>